import { Package, ShippingContainer, Truck } from '@phosphor-icons/react';
import { Images } from '../../images';

export const CommonConstant = {
  user: '3pl-user',
  environment: 'environment',
  currentRegion: 'currentRegion',
  defaultImage: Images.default,
  metadata: 'metadata',
  defaultPageSize: 10,
  noPage: 'no-page',
  noTab: 'no-tab',
  permissionMeta: 'permission-meta',
  pageSizes: [
    { key: 10, value: 10, text: '10 results per page' },
    { key: 25, value: 25, text: '25 results per page' },
    { key: 50, value: 50, text: '50 results per page' },
    { key: 100, value: 100, text: '100 results per page' },
  ],
  sortDirection: {
    ascending: 'asc',
    descending: 'desc',
  },
  loggedInTime: 'loggedInTime',
  tableFilter: 'tableFilter',
};

export const ErrorMessageConstant = {
  defaultAPIError: 'Something went wrong, please contact administrator',
};

export const OrderUrlKeys = {
  'pending-shipment': 'Pending Shipment',
  'pending-fulfillment': 'Pending Fulfillment',
  canceled: 'Canceled',
  shipped: 'Shipped',
  paused: 'paused',
  returns: 'Returns',
};

export const PackagingStatus = {
  readyToPack: 'ready_to_pack',
  inTransit: 'in_transit',
};

export const OrderStatus = {
  pendingShipment: 'Pending Shipment',
  pendingFulfillment: 'Pending Fulfillment',
  canceled: 'Canceled',
  shipped: 'Shipped',
  returns: 'Returns',
};

export const initialImageCrop = {
  unit: '%',
  width: 50,
  height: 50,
  x: 25,
  y: 25,
};

export const BYTES_FOR_ONE_MB = 1024 * 1024;

export const measurementOptions = [
  {
    key: 'ft',
    text: 'ft',
    value: 'ft',
  },
  {
    key: 'm',
    text: 'm',
    value: 'm',
  },
];

export const bayOptions = [
  {
    key: 'pallet',
    text: 'Pallet',
    value: 'pallet',
  },
  {
    key: 'bin',
    text: 'Bin',
    value: 'bin',
  },
];

export const decimalMask = {
  allowDecimal: true,
  allowLeadingZeroes: false,
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
};

export const Tabs = {
  warehouseTabs: {
    details: 'details',
    zones: 'zones',
  },
  settingsTab: {
    integration: 'integration',
    organisation: 'organisation',
    users: 'users',
    warehouse: 'warehouse',
    fulfillment: 'fulfillment',
    servicesRates: 'services-rates',
    packagingMaterials: 'packaging-materials',
    shipnode: 'shipnode',
    fulfillmentTabs: {
      waveRules: 'wave-rules',
      totes: 'totes',
      pallets: 'pallets',
      emailPickList: 'email-picklist',
      packingStations: 'packing-stations',
    },
  },
  crmDetailTabs: {
    rate: 'rate',
    invoices: 'invoices',
  },
  InventoryTabs: {
    new: 'new',
    feed: 'feed',
  },
  TransferTabs: {
    scheduled: 'scheduled',
    suggested: 'suggested',
    transferWaves: 'transfer-waves',
  },
  WavesTabs: {
    building: 'building',
    ready: 'ready',
    in_progress: 'in_progress',
    sorting: 'sorting',
    sorted: 'sorted',
    all: 'all',
    unassigned: 'unassigned',
    analytics: 'analytics',
    sortedTabs: {
      tote: 'tote',
      single: 'single',
    },
  },
  OrderTabs: {
    pendingFulfillment: 'pending-fulfillment',
    paused: 'paused',
    shipped: 'shipped',
    tracking: 'tracking',
  },
  PackingTabs: {
    toPack: 'to-pack',
    complete: 'complete',
  },
};

export const publicStatusOptions = [
  {
    text: 'Public',
    value: 'public',
  },
  {
    text: 'Private',
    value: 'private',
  },
];

export const ShippingTypesIcons = {
  FCL: <ShippingContainer />,
  LCL: <ShippingContainer />,
  FTL: <Truck />,
  LTL: <Truck />,
  SP: <Package />,
};

export const ShippingTypes = [
  {
    text: 'Full Container Load(s)',
    value: 'FCL',
    icon: ShippingTypesIcons.FCL,
  },
  {
    text: 'Less than Container Load',
    value: 'LCL',
    icon: ShippingTypesIcons.LCL,
  },
  {
    text: 'Less than / Full Truck Load(s)',
    value: 'LTL',
    icon: ShippingTypesIcons.LTL,
  },
  {
    text: 'Parcel(s)',
    value: 'SP',
    icon: ShippingTypesIcons.SP,
  },
];

export const StorageIntegrationTypes = {
  FBA: 'spapi',
};

export const unitsTextMap = {
  l: 'Liters',
  L: 'Liters',
  units: 'Units',
  gal: 'Gallons',
  ml: 'Milliliters',
  mL: 'Milliliters',
  'fl oz': 'Fluid Ounces',
  kg: 'Kilograms',
  lb: 'Pounds',
  g: 'Grams',
  oz: 'Ounces',
  cm: 'Centimeters',
  in: 'Inches',
};

export const ShipmentTypeKeys = {
  PO: 'Purchase Order',
  FP: 'Fulfillment Provider',
  SP: 'Storage Provider',
};

export const aisleSides = {
  left: 1,
  right: 2,
};

export const InventoryAdjustmentTypes = {
  increase: 'increase',
  decrease: 'decrease',
  transfer: 'initiate_transfer',
  completeTransfer: 'complete_transfer',
  overwrite: 'overwrite',
};

export const ItemStates = {
  conflict: 'Conflict',
  resolved: 'Resolved',
  discontinued: 'Discontinued',
  inactive: 'Inactive',
  component: 'Component',
};

export const ShippingSpeedOptions = [
  {
    text: 'Standard',
    value: 'Standard',
    key: 'Standard',
  },
  {
    text: 'Priority',
    value: 'Priority',
    key: 'Priority',
  },
  {
    text: 'Expedited',
    value: 'Expedited',
    key: 'Expedited',
  },
];

export const WaveTypes = {
  shipInBox: 'Ship in Box',
  singleItemOrder: 'Single-Item Orders',
  multiItemOrders: 'Multi-Item Orders',
};

export const billingCycleOptions = [
  {
    text: '1',
    value: 1,
    key: 1,
  },
  {
    text: '2',
    value: 2,
    key: 2,
  },
  {
    text: '3',
    value: 3,
    key: 3,
  },
  {
    text: '4',
    value: 4,
    key: 4,
  },
  {
    text: '5',
    value: 5,
    key: 5,
  },
  {
    text: '6',
    value: 6,
    key: 6,
  },
  {
    text: '7',
    value: 7,
    key: 7,
  },
  {
    text: '8',
    value: 8,
    key: 8,
  },
  {
    text: '9',
    value: 9,
    key: 9,
  },
  {
    text: '10',
    value: 10,
    key: 10,
  },
  {
    text: '11',
    value: 11,
    key: 11,
  },
  {
    text: '12',
    value: 12,
    key: 12,
  },
  {
    text: '13',
    value: 13,
    key: 13,
  },
  {
    text: '14',
    value: 14,
    key: 14,
  },
  {
    text: '15',
    value: 15,
    key: 15,
  },
  {
    text: '16',
    value: 16,
    key: 16,
  },
  {
    text: '17',
    value: 17,
    key: 17,
  },
  {
    text: '18',
    value: 18,
    key: 18,
  },
  {
    text: '19',
    value: 19,
    key: 19,
  },
  {
    text: '20',
    value: 20,
    key: 20,
  },
  {
    text: '21',
    value: 21,
    key: 21,
  },
  {
    text: '22',
    value: 22,
    key: 22,
  },
  {
    text: '23',
    value: 23,
    key: 23,
  },
  {
    text: '24',
    value: 24,
    key: 24,
  },
  {
    text: '25',
    value: 25,
    key: 25,
  },
  {
    text: '26',
    value: 26,
    key: 26,
  },
  {
    text: '27',
    value: 27,
    key: 27,
  },
  {
    text: '28',
    value: 28,
    key: 28,
  },
  {
    text: '29',
    value: 29,
    key: 29,
  },
  {
    text: '30',
    value: 30,
    key: 30,
  },
  {
    text: '31',
    value: 31,
    key: 31,
  },
];
